import { useState } from 'react';
import './App.css';
import FontPreloader from './FontPreloader';
import CliComponent from './terminalcli';
import logo from './logo.png';
import LoginPage from "./LoginPage"

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  if (!authenticated) {
    return (
      <div className="App">
        <FontPreloader />
        <LoginPage onLoginSuccess={() => setAuthenticated(true)} />
      </div>
    );
  }

  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return (
    <div className="App">
      <FontPreloader />
      <img src={logo} alt="logo" className="logo" />
      <div>
        <span className="v2 easter-egg">IHR &nbsp;</span>
        <span className="v3 easter-egg">YHUVLRQ 5.6 &nbsp;</span>
        <span className="v1 easter-egg">{formattedDate}</span>
        <span className="v2 easter-egg">IHR &nbsp;</span>
        <span className="v3 easter-egg">YHUVLRQ 5.6 &nbsp;</span>
        <span className="v1 easter-egg">{formattedDate}</span>
      </div>

      <CliComponent />
    </div>
  );
}

export default App;
